import { render, staticRenderFns } from "./setpeoples.vue?vue&type=template&id=4c18d456&scoped=true&"
import script from "./setpeoples.vue?vue&type=script&lang=js&"
export * from "./setpeoples.vue?vue&type=script&lang=js&"
import style0 from "./setpeoples.vue?vue&type=style&index=0&id=4c18d456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18d456",
  null
  
)

export default component.exports